export const useNoCache = () => {
  const { ssrContext } = useNuxtApp()
  if (ssrContext) ssrContext.event.node.res.setHeader('X-Cache-Control', 'no-cache')
}
